module.exports = __webpack_public_path__ + "static/media/empty_course.0b893df6.svg";